<template>
  <div v-if="magnoliaGetters.showKioskOrCatalog($flags, showColumnKiosk, showColumnCatalog)">
    <p class="mb-4 text-lg font-bold">
      {{ title }}
    </p>
    <div class="flex flex-wrap gap-5">
      <SharedLink
        v-for="(socialLink, index) in socialLinks"
        :key="index"
        class="mb-6"
        :data-type="socialLink.link.target"
        :link="socialLink.link"
      >
        <NuxtImg
          :alt="socialLink.link.name"
          :src="socialLink.src"
          :srcset="socialLink.srcSet"
          loading="lazy"
          width="40"
          height="40"
        />
      </SharedLink>
    </div>
    <a
      class="flex items-center gap-1 font-bold hover:underline"
      :href="$t('footerCarrerAtKik')"
    >
      <KikIcon
        icon="career"
        size="base"
      />
      <span class="mb-1">{{ $t("Career at KiK") }}</span>
    </a>
    <p class="my-4 text-sm font-light">
      {{ $t("Discover all vacancies in our more than 2,600 stores and our European headquarters.") }}
    </p>
    <div class="flex flex-wrap gap-5">
      <SharedLink
        v-for="(image, index) in sealImages"
        :key="index"
        :data-type="image.link?.target"
        :link="image.link"
      >
        <NuxtImg
          :alt="image.alt"
          :src="image.src"
          :srcset="image.srcSet"
          loading="lazy"
          width="64"
          height="64"
        />
      </SharedLink>
    </div>
  </div>
</template>

<script lang="ts" setup>
import magnoliaGetters from '~/composables/getters/magnoliaGetters';

interface Props {
  title?: string;
  showColumnKiosk?: boolean;
  showColumnCatalog?: boolean;
  socialLinks?: any[];
  sealImages?: any[];
}

withDefaults(defineProps<Props>(), {
  title: undefined,
  showColumnKiosk: true,
  showColumnCatalog: true,
  socialLinks: () => [],
  sealImages: () => [],
});

const { $flags } = useNuxtApp();
</script>
